import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/EwoActions";
import * as api from "../../api/EwoApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getRootCauseFamilies() {
    try {
        const { data } = yield api.getRootCauseFamilies();
        yield put(actions.setRootCauseFamilies(data || undefined));
    } catch (error) {
        yield put(actions.setRootCauseFamilies(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getRootCauseFamilyOptions(payload) {
    try {
        const { data } = yield api.getRootCauseFamilyOptions(payload.payload);
        yield put(actions.setRootCauseFamilyOptions(data || undefined));
    } catch (error) {
        yield put(actions.setRootCauseFamilyOptions(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getOperatorFiveWsOneHAnalysis() {
    try {
        const { data } = yield api.getOperatorFiveWsOneHAnalysis();
        yield put(actions.setOperatorFiveWsOneHAnalysis(data || undefined));
    } catch (error) {
        yield put(actions.setOperatorFiveWsOneHAnalysis(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* postEwoFormCreateWithFile(action) {
    yield put(resetBackdrop());

    try {
        const { data } = yield api.postEwoFormCreateWithFile(action.payload);
        yield put(actions.setEwoFormCreateWithFile(data || undefined));
        yield put(showSuccessSnackbar({ data }));
    } catch (error) {
        yield put(actions.setEwoFormCreateWithFile(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postEwoFormCreateWithOperatorFields(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postEwoFormCreateWithOperatorFields(action.payload);
        yield put(actions.setEwoFormCreateWithOperatorFields(data || undefined));
        yield put(showSuccessSnackbar({ data }));
    } catch (error) {
        yield put(actions.setEwoFormCreateWithOperatorFields(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCheckHasEwoForm(action) {
    try {
        const { data } = yield api.getCheckHasEwoForm(action.payload);
        yield put(actions.setCheckTaskHasEwoForm(data || undefined));
    } catch (error) {
        yield put(actions.setCheckTaskHasEwoForm(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* getOperatorFieldsByTaskId(action) {
    try {
        const { data } = yield api.getOperatorFieldsByTaskId(action.payload);
        yield put(actions.setOperatorFieldsByTaskId(data || undefined));
    } catch (error) {
        yield put(actions.setOperatorFieldsByTaskId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* getEwoFormsList(payload) {
    try {
        const { data } = yield api.getEwoForms(payload);
        yield put(actions.setEwoFormsList(data || undefined));
    } catch (error) {
        yield put(actions.setEwoFormsList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* getEwoFormDetailById(action) {
    try {
        const { data } = yield api.getEwoFormDetailById(action.payload);
        yield put(actions.setEwoFormDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setEwoFormDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* postEwoFormFileWithEwoId(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postAddEwoFormFileWithEmergencyWorkOrdId(action.payload);
        yield put(showSuccessSnackbar(data.message));
        yield api.getEwoFormDetailById(action.payload.id);
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ROOT_CAUSE_FAMILIES, getRootCauseFamilies);
    yield takeEvery(actions.Types.GET_OPERATOR_FIVEWS_ONEH_ANALYSIS, getOperatorFiveWsOneHAnalysis);
    yield takeEvery(actions.Types.POST_EWO_FORM_CREATE_WITH_FILE, postEwoFormCreateWithFile);
    yield takeEvery(actions.Types.POST_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS, postEwoFormCreateWithOperatorFields);
    yield takeEvery(actions.Types.GET_CHECK_TASK_HAS_EWO_FORM, getCheckHasEwoForm);
    yield takeEvery(actions.Types.GET_OPERATOR_FIELDS_BY_TASK_ID, getOperatorFieldsByTaskId);
    yield takeEvery(actions.Types.GET_EWO_FORMS_LIST, getEwoFormsList);
    yield takeEvery(actions.Types.GET_EWO_FORM_DETAIL_BY_ID, getEwoFormDetailById);
    yield takeEvery(actions.Types.GET_ROOT_CAUSE_FAMILY_OPTIONS, getRootCauseFamilyOptions);
    yield takeEvery(actions.Types.POST_EWO_FORM_FILE_WITH_EWO_ID, postEwoFormFileWithEwoId);
}

const EwoSaga = [fork(watchAll)];

export default EwoSaga;